import { RaceProgressRegistrationDataRaw } from './interfaces/race_progress_registration_data_raw.interface';
import { RaceDocument } from './race_document';
import { User } from './user';

export class Registration {
  user!: User;

  deleted: boolean;
  deletedTimestamp: string;
  deletedAuthor: string;

  clUid: string;
  startNumber: string;
  // team: string;
  info: string;
  techMark!: Date | null;
  techComment: string;
  startFee: number | string;
  orgComment: string;

  gpsTracker: string;
  trackerReturnedAt: number;

  chronoTag: number;
  tagReturnedAt: number;

  allDocumentsValid: boolean;
  registrationTime: Date;

  documents: RaceDocument[] = [];

  answers: string[] =[];

  crew!: User[];

  className?: string;
  currentPhoto: string = '';

  set doc_confirmed(_) {}

  set doc_invalid(_) {}

  set doc_new(_) {}

  get doc_confirmed() {
    const issetFiles = this.documents.some((doc) => doc.files.length > 0);
    if (!issetFiles) {
      return false;
    } else {
      return !this.documents.some(
        (doc) => doc.valid !== true && doc.files.length > 0
      );
    }
  }

  get doc_invalid() {
    return this.documents.some(
      (doc) => doc.valid === false && doc.files.length > 0
    );
  }

  get doc_new() {
    return this.documents.some(
      (doc) => doc.valid === undefined && doc.files.length > 0
    );
  }

  // TODO проставить тип RaceProgressRegistrationDataRaw
  constructor(obj: RaceProgressRegistrationDataRaw) {
    if (obj.user) {
      this.user = new User(obj.user);
      this.currentPhoto = this.user.photo;
    }

    this.deleted = obj.deleted;
    this.deletedTimestamp = obj.deletedTimestamp;
    this.deletedAuthor = obj.deletedAuthor;

    this.clUid = obj.clUid;

    this.startNumber = obj.startNumber;
    if (!this.startNumber) {
      this.startNumber = '-';
    }
    // this.team = obj.user.team;
    this.info = obj.info;
    this.techMark = obj.techMark ? new Date(+obj.techMark) : null;
    this.techComment = obj.techComment;
    this.startFee = obj.startFee;
    this.orgComment = obj.orgComment || '';

    this.gpsTracker = obj.gpsTracker;
    this.trackerReturnedAt = obj.trackerReturnedAt;

    this.chronoTag = obj.chronoTag
    this.tagReturnedAt = obj.tagReturnedAt;

    this.allDocumentsValid = obj.allDocumentsValid;
    this.registrationTime = new Date(+obj.registrationTime);

    this.documents = obj.documents.map((document: any) => {
      if (document.date) {
        document.date = new Date(document.date);
      }
      return document;
    });

    this.answers = obj.answers;

    if (obj.crew) {
      this.crew = obj.crew.map((crewMember: any) => {
        return new User(crewMember);
      })
    }
  }
}
